module.exports = [{
      plugin: require('/home/alexandre/www/frellas/willian/asiaservice/node_modules/gatsby-plugin-typography/gatsby-browser.js'),
      options: {"plugins":[],"pathToConfigModule":"src/util/typography.js"},
    },{
      plugin: require('/home/alexandre/www/frellas/willian/asiaservice/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-140606437-1"},
    }]
